import { Component, OnInit } from '@angular/core';

import { LanguageSelectorModel } from 'src/@prep/shared/language-selector/model/language-selector.model';
import { LanguageSelectorService } from 'src/@prep/shared/language-selector/service/language-selector.service';
import { TopToolbarTextDataEN } from '../toolbar-multi-lang/en-US';
import { TopToolbarTextDataES } from '../toolbar-multi-lang/es-EU';
import { TopToolbarTextDataIT } from '../toolbar-multi-lang/it-IT';

@Component({
  selector: 'prep-toolbar-release-notes',
  templateUrl: './toolbar-release-notes.component.html',
  styleUrls: ['./toolbar-release-notes.component.scss']
})
export class ToolbarReleaseNotesComponent implements OnInit {

  selectedLang: LanguageSelectorModel = this.languageSelectorService.getCurrentLanguage();
  LangTextData: any;


  constructor(private languageSelectorService: LanguageSelectorService,) {
    this.languageSelectorService.language$.subscribe(lang => {
      this.selectedLang = lang;
      console.log('🌍 Language changed:', lang, lang.code, this.selectedLang.code);
      switch (this.selectedLang.code) {
        case 'en': {
          this.LangTextData = TopToolbarTextDataEN;
          console.log('🌍 English Language:', this.LangTextData);
          break;
        }
        case 'es': {
          this.LangTextData = TopToolbarTextDataES;
          console.log('🌍 English Language:', this.LangTextData);
          break;
        }
        case 'it': {
          this.LangTextData = TopToolbarTextDataIT;
          console.log('🌍 English Language:', this.LangTextData);
          break;
        }
        default: {
          this.LangTextData = TopToolbarTextDataEN;
          console.log('🌍 Default Language:', this.LangTextData);
          break;
        }
      }
    });
  }

  ngOnInit() {
  }

  clickGoToReleaseNotes() {
    const link = document.createElement('a');
    link.target = '_blank';
    // link.href = 'https://app.productstash.io/roadmaps/5f560a4ac67165002916ff42/public#completed';
    link.href = 'https://app.loopedin.io/roadmaps/5f560a4ac67165002916ff42/public#completed';
    link.setAttribute('visibility', 'hidden');
    link.click();
  }

}
